import { API, API_DOMAIN } from '../constants/constants';
import { normalizeUserMetaNonPIRequestBody } from '../utils/userMetaNormalization';
import {
  normalizeLoginPayload,
  normalizeTermsAgreePayload,
  normalizeUpdateUserPayload,
  normalizeUserId,
  normalizeVerifyEmailChangePayload,
} from '../utils/userNormalization';

export async function agreeTermsOfService(userData) {
  const payload = normalizeTermsAgreePayload(userData);
  const normalizedId = normalizeUserId(userData?.id ?? userData?._id);
  const ret = await API.put(`/user/terms-of-service/${normalizedId}/agree`, payload);
  return ret.data || null;
}

export async function fetchTermsOfServiceDocMeta() {
  const ret = await API.get(`/user/terms-of-service/meta`);
  return ret.data || null;
}

export async function fetchTermsOfServiceDoc() {
  const ret = await API.get(`/user/terms-of-service/doc`);
  return ret.data || null;
}

export async function verifyUserChangedEmail(userData) {
  const payload = normalizeVerifyEmailChangePayload(userData);
  const ret = await API.post(`/user/verify-email-change`, payload);
  return ret.data || null;
}

export async function updateUser(userData) {
  const payload = normalizeUpdateUserPayload(userData);
  const normalizedId = normalizeUserId(userData?.id ?? userData?._id);
  const ret = await API.put(`/user/info/${normalizedId}`, payload);
  return ret.data || null;
}

export async function updateUserWithPrivilege(userData) {
  try {
    const payload = normalizeUpdateUserPayload(userData);
    const normalizedId = normalizeUserId(userData?.id ?? userData?._id);
    const ret = await API.put(`/user/withPrivilege/${normalizedId}`, payload);
    return ret.data || null;
  } catch (err) {
    return err;
  }
}

export async function loginUser(userData) {
  const payload = normalizeLoginPayload(userData);
  const res = await fetch(`${API_DOMAIN}/user/login`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  });

  const ret = await res.json();

  return ret;
}

export async function getUserMetaDataNonPIUserSettings(userSub) {
  const ret = await API.get(`/user-meta/${userSub}/non-pi`);

  return ret.data || null;
}

export async function updateUserMetaDataNonPIUserSettings(userSub, requestBody) {
  const ret = await API.put(`/user-meta/${userSub}/non-pi`, normalizeUserMetaNonPIRequestBody(requestBody ?? {}));

  return ret.data || null;
}
